module.exports = __webpack_public_path__ + "static/media/served.8912f481.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/partner-reports/served.svg
// module id = 361
// module chunks = 1